"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.grammar = exports.pattern = exports.str = exports.fn = void 0;
const fn = (ret_cl) => ({
    kind: "Value.fn",
    ret_cl,
});
exports.fn = fn;
const str = (value) => ({
    kind: "Value.str",
    value,
});
exports.str = str;
const pattern = (label, value) => ({
    kind: "Value.pattern",
    label,
    value,
});
exports.pattern = pattern;
const grammar = (name, delayed) => ({
    kind: "Value.grammar",
    name,
    delayed,
});
exports.grammar = grammar;
//# sourceMappingURL=value.js.map